<template>
  <div v-loading="loading">
    <div class="nav-head">
      <h3>个人信息设置</h3>
    </div>
    <div class="info">
      <el-form ref="form" :model="fromData" label-width="100px">
        <el-form-item label="用户名:">
          <el-input v-model="fromData.userName" readonly size="small"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-input v-model="fromData.buyerStatusName" readonly size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:">
          <div class="flex-center-end">
            <el-input v-model="fromData.phone" readonly size="small"></el-input>
            <el-button type="primary" @click="reset" size="small">修改</el-button>
          </div>
        </el-form-item>
        <el-form-item label="所在地:">
          <span>{{fromData.areaRegionName}}</span>-
          <span>{{fromData.areaProvinceName}}</span>-
          <span>{{fromData.areaCityName}}</span>
        </el-form-item>
        <el-form-item label="电子邮箱:">
          <div class="flex-center-end">
            <el-input v-model="fromData.eMail" readonly size="small"></el-input>
            <el-button type="primary" size="small" @click="email.show = true,email.value = ''">修改</el-button>
          </div>
        </el-form-item>
        <el-form-item label="真实姓名:">
          <el-input v-model="fromData.realName" readonly size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证号:">
          <el-input v-model="fromData.idCard" readonly size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证照片:" v-if="fromData.idCardFront">
          <!-- <img :src="fromData.idCardFront" alt="" style="width: 100%; height: 300px"> -->
          <!-- <img :src="fromData.idCardReverse" alt="" style="width: 100%; height: 300px"> -->
          <el-image
            style="width: 300px; height: 150px"
            :src="fromData.idCardFront"
            :preview-src-list="[fromData.idCardReverse]"
          ></el-image>
          <el-image
            style="width: 300px; height: 150px"
            :src="fromData.idCardFront"
            :preview-src-list="[fromData.idCardReverse]"
          ></el-image>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="修改手机号码"
      :visible.sync="dialogShow.show"
      width="500px"
      :close-on-click-modal="false"
      @close="dialogShow.show1 = true"
    >
      <el-dialog title="获取短信验证码" :visible.sync="dialogShow.show3" append-to-body width="300px">
        <div class="flex-center-end">
          <el-input ref="authCode" v-model="authCode.value"></el-input>
          <img :src="authCode.url" alt="">
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogShow.show3 = !dialogShow.show3" size="small">取消</el-button>
          <el-button @click="getCode" size="small" type="primary">获取短信验证码</el-button>
        </div>
      </el-dialog>
      <div>
        <el-form ref="codeInfo" label-width="110px" :rules="rules" :model="codeInfo">
          <el-form-item :label="dialogShow.show1?'手机号码':'新手机号码'" prop="phone">
            <el-input v-model="fromData.phone" :disabled="true" v-if="dialogShow.show1"></el-input>
            <el-input v-model="codeInfo.phone" v-else></el-input>
            <p v-show="dialogShow.show1">若手机号码不可用请联系客户经理处理</p>
          </el-form-item>
          <el-form-item label="短信验证码:" prop="code">
            <div class="flex-center-end">
              <el-input v-model="codeInfo.code"></el-input>
              <el-button @click="getKaptcha">获取验证码</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="next" size="small" type="primary">下一步</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改电子邮箱" :visible.sync="email.show" append-to-body width="500px">
      <el-form ref="email" label-width="110px" :rules="rules" :model="email">
        <el-form-item label="电子邮箱">
          <el-input v-model="fromData.eMail" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新电子邮箱" prop="value">
          <el-input v-model="email.value"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="email.show = !email.show" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="getEmail">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import kaptcha from "@/lib/data-service/default/web_common_kaptcha";
import phoneRegister from "@/lib/data-service/default/web_common_register";
import personageDetailByBuyerId from "@/lib/data-service/default/web_personage_personageDetailByBuyerId";
import personageSet from "@/lib/data-service/default/web_personage_personageSet";
import phoneCodeCheck from "@/lib/data-service/default/web_common_phoneCodeCheck";

export default {
  name: "personage-info",
  data() {
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      if (!Number.isInteger(+value)) {
        callback(new Error("请输入数字值"));
      } else {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error("电话号码格式不正确"));
        }
      }
    };
    var isEmail = (rule, value, callback) => {
      const reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      if (!value) {
        return callback(new Error("请输入邮箱"));
      } else if (!reg.test(value)) {
        callback(new Error("输入邮箱格式不正确！"));
      } else {
        callback();
      }
    };
    return {
      fromData: {
        phone: ""
      },
      loading: true,
      email: {
        show: false,
        value: ""
      },
      codeInfo: {
        phone: "",
        code: ""
      },
      dialogShow: {
        show: false,
        show1: true,
        show3: false
      },
      authCode: {
        url: "",
        value: "",
        show: false
      },
      rules: {
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        phone: [{ validator: checkPhone, trigger: "blur" }],
        value: [{ validator: isEmail, trigger: "blur" }]
      }
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getKaptcha() {
      this.dialogShow.show3 = true;
      this.authCode.value = "";
      kaptcha().then(res => {
        this.authCode.url = res.img;
        this.authCode.uuid = res.uuid;
        this.$refs.authCode.focus();
      });
    },
    getEmail() {
      this.$refs["email"].validate(valid => {
        if (valid) {
          //   this.fromData.eMail = this.email.value;
          personageSet({
            eMail: this.email.value,
            phone: this.fromData.phone
          }).then(res => {
            console.log(res);
            this.email.show = false;
            this.getUserInfo();
          });
        } else {
          return false;
        }
      });
    },
    getUserInfo() {
      personageDetailByBuyerId().then(res => {
        this.loading = false;
        this.fromData = res.personageDetailResult;
      });
    },
    getCode() {
      if (!this.authCode.value)
        return this.$message({ type: "warning", message: "请输入短信验证码" });
      let data = {
        phoneNumber: !this.dialogShow.show1
          ? this.codeInfo.phone
          : this.fromData.phone,
        verificationCode: this.authCode.value,
        roleType: 2,
        uuid: this.authCode.uuid
      };
      phoneRegister(data).then(
        res => {
          this.$message({ type: "success", message: "发送成功，请稍等！" });
        },
        error => {}
      );
      this.dialogShow.show3 = false;
    },
    next() {
      if (!this.dialogShow.show1) {
        this.$refs["codeInfo"].validate(valid => {
          if (valid) {
            if (this.fromData.phone == this.codeInfo.phone)
              return this.$message({
                type: "warning",
                message: "修改手机号码不能和原手机号一致！"
              });
            let data = {
              smsCode: this.codeInfo.code,
              phone: this.codeInfo.phone
            };
            phoneCodeCheck(data).then(res => {
              personageSet({
                phone: this.codeInfo.phone,
                eMail: this.fromData.eMail
              }).then(res => {
                console.log(res);
                this.dialogShow.show = false;
                this.getUserInfo();
              });
            });
          } else {
            return false;
          }
        });
      } else {
        let data = {
          smsCode: this.codeInfo.code,
          phone: this.fromData.phone
        };
        this.$refs["codeInfo"].validateField("code");
        if (!this.codeInfo.code) return;
        phoneCodeCheck(data).then(res => {
          this.dialogShow.show1 = false;
          this.codeInfo.code = "";
        });
      }
    },
    reset() {
      this.dialogShow = {
        show: true,
        show1: true,
        show3: false
      };
      this.$nextTick(() => {
        this.$refs["codeInfo"].resetFields();
      });
    }
  }
};
</script>
<style lang="less" scoped>
.nav-head {
  background: #ecf6ff;
  font-size: 17px !important;
  padding: 7px 30px;
  font-weight: bold;
  position: relative;
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 3px;
    background: #237dc9;
  }
}
.info {
  margin: 20px 0;
  width: 50%;
}
/deep/.el-input {
  input {
    border-radius: 0;
  }
}
/deep/.el-button {
  margin-left: 10px;
  border-radius: 0;
  button {
    border-radius: 0;
  }
}
</style>
